import { useCallback, useState } from "react";

import { readStored, SIDEBAR_STORAGE_KEY, writeStored } from "../ui/preferences";

/** Whether the sidebar is collapsed to icons (64 px) or expanded (248 px). The choice is kept in this browser. */
export function useSidebarCollapsed(): readonly [boolean, () => void] {
  const [collapsed, setCollapsed] = useState(() => readStored(SIDEBAR_STORAGE_KEY) === "collapsed");
  const toggle = useCallback(() => {
    setCollapsed((previous) => {
      writeStored(SIDEBAR_STORAGE_KEY, previous ? "expanded" : "collapsed");
      return !previous;
    });
  }, []);
  return [collapsed, toggle];
}
